import React from 'react';
import Button from '../Button';
import './Header.scss'
import Buttons from '../../models/Comms/common/Buttons';
import Instructions from '../Instructions/Instructions';

const Header = ({ intro, buttonset,buttons, backButtonHandler}) =>{

    return(
        <header className="content-header">

            <div className="content-header-button-holder">
                <div className={'back-btn-container'}>
                    <Button variant='back' text="back" onClick={backButtonHandler} />
                </div>
            </div>

            <div className="intro">
                <Instructions body={intro} />
            </div>

            <div>
                {buttons}
                {buttonset && <Buttons buttonSet={buttonset} className='content-header-button-stack' />}
            </div>
        </header>
    )
}
export default Header
